import { SvgIcon } from '@material-ui/core';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';

import { styles } from './CodeSquare.styles';

export type CodeSquareIconProps = WithStyles<typeof styles>;

const CodeSquareIconComponent: React.FC<CodeSquareIconProps> = ({ classes }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      classes={{ root: classes.root }}
    >
      <path
        d="M11.0833 11.5205L13.5833 9.02051L11.0833 6.52051M6.91667 6.52051L4.41667 9.02051L6.91667 11.5205M5.5 16.5205H12.5C13.9001 16.5205 14.6002 16.5205 15.135 16.248C15.6054 16.0083 15.9878 15.6259 16.2275 15.1555C16.5 14.6207 16.5 13.9206 16.5 12.5205V5.52051C16.5 4.12038 16.5 3.42031 16.2275 2.88553C15.9878 2.41513 15.6054 2.03267 15.135 1.79299C14.6002 1.52051 13.9001 1.52051 12.5 1.52051H5.5C4.09987 1.52051 3.3998 1.52051 2.86502 1.79299C2.39462 2.03267 2.01217 2.41513 1.77248 2.88553C1.5 3.42031 1.5 4.12038 1.5 5.52051V12.5205C1.5 13.9206 1.5 14.6207 1.77248 15.1555C2.01217 15.6259 2.39462 16.0083 2.86502 16.248C3.3998 16.5205 4.09987 16.5205 5.5 16.5205Z"
        stroke="#7E8899"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CodeSquareIcon = withStyles(styles)(CodeSquareIconComponent);
